export enum FeedbackActionTypes {
    LIST_REQUEST = '@@Feedback/LIST_REQUEST',
    LIST_SUCCESS = '@@Feedback/LIST_SUCCESS',
    LIST_ERROR = '@@Feedback/LIST_ERROR',
    LIST_CLEAR = '@@Feedback/LIST_CLEAR',

    SELECT = '@@Feedback/SELECT',
    SELECTED = '@@Feedback/SELECTED',
    CLEAR_SELECTED = '@@Feedback/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@Feedback/CREATE_REQUEST',
    CREATE_SUCCESS = '@@Feedback/CREATE_SUCCESS',
    CREATE_ERROR = '@@Feedback/CREATE_ERROR',
    
    READ_REQUEST = '@@Feedback/READ_REQUEST',
    READ_SUCCESS = '@@Feedback/READ_SUCCESS',
    READ_ERROR = '@@Feedback/READ_ERROR',

    UPDATE_REQUEST = '@@Feedback/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@Feedback/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@Feedback/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@Feedback/DELETE_REQUEST',
    DELETE_SUCCESS = '@@Feedback/DELETE_SUCCESS',
    DELETE_ERROR = '@@Feedback/DELETE_ERROR',
    
    DOWNLOAD_REQUEST = '@@Feedback/DOWNLOAD_REQUEST',
    DOWNLOAD_SUCCESS = '@@Feedback/DOWNLOAD_SUCCESS',
    DOWNLOAD_ERROR = '@@Feedback/DOWNLOAD_ERROR',
}

export interface FeedbackUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
    readonly downloading: boolean
    readonly downloadURL : string
}
